export default __webpack_public_path__ + "images/blue-50.png";